<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.33325 2.16797H11.6666M9.99992 12.168L12.4999 9.66797M16.6666 12.168C16.6666 15.8499 13.6818 18.8346 9.99992 18.8346C6.31802 18.8346 3.33325 15.8499 3.33325 12.168C3.33325 8.48607 6.31802 5.5013 9.99992 5.5013C13.6818 5.5013 16.6666 8.48607 16.6666 12.168Z"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>